import { CredentialValidationResponse } from 'vue/types/vue';

class ToolsImpl {


  passwordValidation(pw: string = ""): CredentialValidationResponse {

    let invalid = false;
    let message = "";
    let header ="";
    
    const re = /^[a-zA-Z0-9åäöÅÄÖ!&#$%_]+$/g
    const pwLength = pw.length >= 5 && pw.length <= 45;

    if(!pwLength)
    {
      header = "Felaktigt lösenord";
      message = "Ditt lösenord behöver vara mellan 5-45 tecken.";
      invalid = true;
    }
    else if(!re.test(pw))
    {
      header = "Ogiltiga tecken";
      message = "Ditt lösenord innehåller ogiltiga tecken. Giltiga tecken: a-ö A-Ö 0-9 ! & # $ % _";
      invalid = true;
    }


    
    const validation: CredentialValidationResponse = {
      invalid: invalid,
      message: message,
      header: header
    }

    return validation;
  }

  usernameValidation(uname: string): CredentialValidationResponse {

    let invalid = false;
    let message = "";
    let header ="";

    const re = /^[a-z0-9]+$/i;
    const unameLength = uname.length >= 5 && uname.length <= 50;

    if(!unameLength)
    {
      header = "Felaktigt användarnamn";
      message = "Ditt användarnamn behöver vara mellan 5-50 tecken."
      invalid = true;
    }
    else if (!re.test(uname))
    {
      header = "Felaktigt användarnamn";
      message = "Ditt användarnamn innehåller ogiltiga tecken. Giltiga tecken: a-z A-Z 0-9";
      invalid = true;

    }

    const validation: CredentialValidationResponse = {
      invalid: invalid,
      message: message,
      header: header
    }

    return validation;

  }
  submitterValidation(submitter: string): CredentialValidationResponse {

    let invalid = false;
    let message = "";
    const header ="";

    const re = /^[-a-zåäö0-9\s_.,]+$/i
    const submitterLength = submitter.length >= 3 && submitter.length <= 50;

    if(!submitterLength)
    {
      message = "Namn ska vara mellan 3-50 tecken.";
      invalid = true;
    }
    else if (!re.test(submitter))
    {
      message = "Namnet innehåller ogiltiga tecken. Giltiga tecken: a-ö A-Ö 0-9 <mellanslan> _ . ,";
      invalid = true;

    }

    const validation: CredentialValidationResponse = {
      invalid: invalid,
      message: message,
      header: header
    }

    return validation;

  }


}

export const Tools = new ToolsImpl();